import { AUTHENTICATION_V2_ENDPOINT } from '@dtx-company/true-common/src/constants/endpoints'
import { EntityTypes } from '@dtx-company/inter-app/src/redux/slices/modal'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useFetcher } from '@dtx-company/inter-app/src/components/org/hooks/useOrgHooks'
import useSWR from 'swr'

export function useProfilePicture({
  entityType
}: {
  token?: string
  entityId?: string
  entityType?: EntityTypes
}): string | undefined {
  const fetcher = useFetcher()
  const { isAuthenticated } = useAuthState()

  const shouldCall = isAuthenticated && entityType === EntityTypes.USER

  const call = shouldCall ? `${AUTHENTICATION_V2_ENDPOINT}/user` : null

  const { data } = useSWR(call, fetcher, {
    revalidateOnMount: true,
    revalidateIfStale: true
  })

  return data?.profilePictureUrl ?? ''
}
